module.exports = __webpack_public_path__ + "static/media/Ashlee Weber Headshot.22a4563b.jpeg";